import React, { useState } from "react";
import { Button, notification } from "antd";
import { useTranslate } from "@refinedev/core";
import {
  axiosInstance,
  getImpersonatedUserLabel,
  isImpersonating,
  restoreImpersonatorSession,
} from "../../authProvider";

/**
 * Persistent bar shown while an admin/superadmin is viewing the app as a customer.
 */
export const ImpersonationBanner: React.FC = () => {
  const translate = useTranslate();
  const [isExiting, setIsExiting] = useState(false);

  if (!isImpersonating()) {
    return null;
  }

  const label = getImpersonatedUserLabel() ?? "";

  const handleExit = async () => {
    setIsExiting(true);
    let stopFailed = false;
    try {
      await axiosInstance.post("/auth/stop-impersonation");
    } catch {
      stopFailed = true;
    }
    const restored = restoreImpersonatorSession();
    if (!restored) {
      notification.error({
        message: translate("users.impersonate.restoreError"),
      });
      window.location.href = "/login";
      return;
    }
    if (stopFailed) {
      notification.warning({
        message: translate("users.impersonate.stopWarning"),
      });
    }
    window.location.href = "/users";
  };

  return (
    <div
      className="flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium text-white"
      style={{ backgroundColor: "#b45309" }}
      role="status"
    >
      <span>
        {translate("users.impersonate.banner", { name: label })}
      </span>
      <Button
        size="small"
        type="default"
        loading={isExiting}
        onClick={handleExit}
      >
        {translate("users.impersonate.exit")}
      </Button>
    </div>
  );
};
